import { memo } from "react";
import { nFormatter } from "@/common/utils/parseNumber";
import ImageIcon from "@/common/images/icons/eye.svg?react";
import VideoIcon from "@/common/images/icons/playIcon.svg?react";
import GalleryIcon from "@/common/images/icons/stack.svg?react";

import "./ViewButton.scss";

export enum ViewButtonType {
  VIDEO = "VIDEO",
  IMAGE = "IMAGE",
  GALLERY = "GALLERY"
}

interface IViewButtonProps {
  count: number;
  type: ViewButtonType;
  onClick?: () => void;
}

const ViewIcon: React.FC<{ type: ViewButtonType }> = ({ type }) => {
  switch (type) {
    case ViewButtonType.IMAGE:
      return <ImageIcon />;
    case ViewButtonType.VIDEO:
      return <VideoIcon />;
    case ViewButtonType.GALLERY:
      return <GalleryIcon />;
    default:
      return null;
  }
};

export const ViewButton: React.FC<IViewButtonProps> = memo(({
  count,
  type,
  onClick
}) => {
  return (
    <div
      className="ViewButton"
      title={`${nFormatter(count)} views`}
      aria-label={`${nFormatter(count)} views`}
      onClick={onClick}
      role={onClick ? "button" : undefined}
    >
      <span className="ViewButton-Icon"><ViewIcon type={type} /></span>
      <div className="ViewButton-Label">{nFormatter(count)}</div>
    </div>
  );
});
